import { useState } from 'react';
import { useStatsigClient } from '@statsig/react-bindings';

import { pausableSurveyStatuses } from '@api/surveys';
import type { SurveyListItem } from '@api/surveys/utilities/types';
import { GATES } from '@constants';
import { ColumnsIcon, IconCTA, OverlayTriggerTooltip } from '@utilities';

import PauseModal from './components/PauseModal';

interface PauseProps {
  isHoverAction?: boolean;
  onSubmit: ({ refreshItems }: { refreshItems: boolean }) => void;
  selectedRows: Array<SurveyListItem>;
}

const Pause = ({ isHoverAction, onSubmit, selectedRows = [] }: PauseProps) => {
  const [isActive, setIsActive] = useState(false);

  const { client } = useStatsigClient();
  const useCalypsoProvider = client.checkGate(GATES.USE_CALYPSO_AS_SURVEY_PROVIDER);

  const handleSubmit = () => {
    setIsActive(false);
    onSubmit({ refreshItems: true });
  };

  const hasSurveyRef = Boolean(selectedRows[0]?.atlasInstantSurveyRef);
  const isOwner = selectedRows[0]?.isOwner;
  const isPausableStatus = pausableSurveyStatuses.includes(selectedRows[0]?.status);
  const isPaused = selectedRows[0]?.isPaused;
  const isSingleSelect = selectedRows.length === 1;
  const isVisible =
    hasSurveyRef &&
    isOwner &&
    isPausableStatus &&
    !isPaused &&
    isSingleSelect &&
    useCalypsoProvider;

  if (!isVisible) return null;

  return (
    <>
      <OverlayTriggerTooltip content={isHoverAction ? 'Pause' : ''}>
        <IconCTA
          data-testid="pause-cta"
          icon={<ColumnsIcon />}
          onClick={() => setIsActive(true)}
          text={isHoverAction ? '' : 'Pause'}
        />
      </OverlayTriggerTooltip>
      {isActive && (
        <PauseModal
          id={selectedRows[0].id}
          onClose={() => setIsActive(false)}
          onSubmit={handleSubmit}
        />
      )}
    </>
  );
};

export default Pause;
